/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgComponentBindDom = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21 9v12H3V3h10M5 6h6M5 18h6m4-14v4h4m-4 0 5-5M6 10h4v4H6v-4zm8 2h4v6h-4v-6z"
      fill="none"
      stroke="currentcolor"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
  </Icon>
);
export { SvgComponentBindDom as ComponentBindDom };
